declare const TweenMax: any;
declare const TimelineMax: any;
declare const Bounce: any;

const DrawSVG = require("../lib/gsap/DrawSVGPlugin");

export class SvgAnimations {

	constructor() {
		const redBlocks = "header.desktop .animate-svg-stroke__wrapper > svg .red-block path";
		const whiteBlocks = "header.desktop .animate-svg-stroke__wrapper > svg .white-block path";

		const tl = new TimelineMax();
		tl.set({}, {}, 0.1);

		tl.fromTo([redBlocks, whiteBlocks], 1, {
			fill: "transparent",
			stroke: "#EE3A43",
			drawSVG: "0%",
		}, {
			fill: "transparent",
			stroke: "#EE3A43",
			drawSVG: "100%",
			ease: "easeIn"
		});

		tl.set(whiteBlocks, {
			fill: "#FFF",
		}, "-=0.5");

		tl.to(redBlocks, 0.5, {
			fill: "#EE3A43",
		}, "-=0.5");

		// tl.timeScale(0.5);
	}
}

export class HeaderAnimations {
	constructor() {
		this.triggerHeaderLogo();
		this.triggerSocialLinks();
		this.triggerSiteSwitcher();
	}

	triggerHeaderLogo() {
		const headerLogo = "body.home > header.desktop .site-branding";
		TweenMax.fromTo(headerLogo, 1, {
			scale: 0,
		}, {
			scale: 1,
			ease: Bounce.easeOut,
			delay: 0.5
		});
	}

	triggerSocialLinks() {
		const socialLinks = "header.desktop .social > a";
		TweenMax.staggerFromTo(socialLinks, 0.5, {
			scale: 0,
		}, {
			scale: 1,
			ease: Bounce.easeOut,
			delay: 0.75
		}, 0.325);
	}

	triggerSiteSwitcher() {
		TweenMax.to("header.desktop .site-switcher", 0.75, {
			rotationX: 0,
			ease: Bounce.easeOut,
			delay: 1.25,
		});
	}
}